import { TemporaryNotification } from '@abgov/ui-components-common';
import { VerificationStatuses } from '../common/constants/statuses';
import { VERIFICATION_ATTEMPT_KEY, VERIFICATION_STATUS_KEY, VERIFICATION_ATTEMPTED_VALUE } from '../utils/globalUtility';


/* -----------------------------
   sessionStorage helpers
------------------------------ */
export const setVerificationAttempted = () => {
  sessionStorage.setItem(
    VERIFICATION_ATTEMPT_KEY,
    VERIFICATION_ATTEMPTED_VALUE
  );
};

export const getLastVerificationStatus = (): number | undefined => {
  const value = sessionStorage.getItem(VERIFICATION_STATUS_KEY);
  if (value === null) {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const setLastVerificationStatus = (status?: number) => {
  if (status === undefined) {
    sessionStorage.removeItem(VERIFICATION_STATUS_KEY);
  } else {
    sessionStorage.setItem(VERIFICATION_STATUS_KEY, String(status));
  }
};

export const wasVerificationAttempted = (): boolean =>
  sessionStorage.getItem(VERIFICATION_ATTEMPT_KEY) === VERIFICATION_ATTEMPTED_VALUE;

export const clearVerificationAttempt = () => {
  sessionStorage.removeItem(VERIFICATION_ATTEMPT_KEY);
};

/* -----------------------------
   verification outcome handler
------------------------------ */

export const handleVerificationOutcome = (
  lastStatus: number | undefined,
  currentStatus: number | undefined,
  attempted: boolean
) => {
  if (!attempted || typeof currentStatus !== 'number') {
    return;
  }

  // SUCCESS: Basic → Pending | Verified
  if (
    lastStatus === VerificationStatuses.Basic &&
    (currentStatus === VerificationStatuses.Pending ||
      currentStatus === VerificationStatuses.Verified)
  ) {
    TemporaryNotification.show(
      'Your Alberta.ca Account verification status has been changed.',
      { type: 'success', duration: 'medium' }
    );

    clearVerificationAttempt();
    return;
  }

  // FAILURE: status unchanged
  if (
    lastStatus === VerificationStatuses.Basic &&
    currentStatus === VerificationStatuses.Basic
  ) {
    TemporaryNotification.show(
      "Your Alberta.ca Account verification status hasn't changed.",
      { type: 'failure', duration: 'medium' }
    );

    clearVerificationAttempt();
  }
};
